export default __webpack_public_path__ + "static/media/1.488eec80.png";